import types from './types';

const INITIAL_STATE = {
  isFetching: false,

  result: [],
};

const authExpiryDaysReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_EXPIRY_DAYS_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_EXPIRY_DAYS_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_EXPIRY_DAYS_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
    };

  default:
    return state;
  }
};

export default authExpiryDaysReducer;
